// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__XzfpS","input":"styles_input__skIPr"};